import { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import CourseCard from "@/components/CourseCard";
import { CATEGORIES } from "@/lib/categories";

export default function Courses() {
  const [params, setParams] = useSearchParams();
  const active = params.get("kategori") || "ehliyet";
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/courses").then(({ data }) => {
      setCourses(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () => courses.filter((c) => c.category === active),
    [courses, active]
  );

  const setCategory = (id) => {
    setParams({ kategori: id });
  };

  return (
    <div data-testid="courses-page">
      <section className="pt-24 md:pt-32 pb-12 max-w-7xl mx-auto px-6 md:px-10">
        <div className="overline text-[color:var(--ek-accent)] mb-4">Tüm Kurslar</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-3xl">
          Uzmanlığınıza yön verecek program burada.
        </h1>
      </section>

      {/* Segmented tabs */}
      <section className="sticky top-16 z-20 bg-white/80 backdrop-blur-xl border-y border-black/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex gap-2 overflow-x-auto no-scrollbar">
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              onClick={() => setCategory(c.id)}
              data-testid={`courses-tab-${c.id}`}
              className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                active === c.id
                  ? "bg-neutral-900 text-white"
                  : "bg-neutral-100 text-neutral-700 hover:bg-neutral-200"
              }`}
            >
              {c.label}
              <span className="ml-2 text-xs opacity-60">
                ({courses.filter((k) => k.category === c.id).length})
              </span>
            </button>
          ))}
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-6 md:px-10">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-neutral-100 rounded-2xl animate-pulse" />
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="py-24 text-center text-neutral-500">Bu kategoride kurs bulunamadı.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((c, i) => (
              <div key={c.id} className="fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <CourseCard course={c} index={i} />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
